import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RichText from '../RichText'
import { useStyles } from './FAQAccordion.styles'

const FAQAccordion = ({ faqs }) => {
  const styles = useStyles()
  if (!faqs || !Array.isArray(faqs)) return null

  return faqs.map((faqSubItem, faqSubItemIndex) => {
    const rawContent = faqSubItem?.content?.raw
    return (
      <Accordion
        className={styles.accordion}
        key={`faqSubItemKey-${faqSubItemIndex}`}
      >
        <AccordionSummary
          className={styles.accordionSummary}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography variant="body1" className={styles.accordionSummaryTitle}>
            {faqSubItem?.heading}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={styles.accordionDetails}>
          {rawContent && (
            <RichText variant="body1" document={JSON.parse(rawContent)} />
          )}
        </AccordionDetails>
      </Accordion>
    )
  })
}
export default FAQAccordion
